import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseUrl } from "store/baseUrls";
import { xApiKey } from "store/apiKeys";
import type { Home, Region } from "./home.model";

export const homeApi = createApi({
  reducerPath: "homeApi",
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      headers.set("Accept", "application/json");
      headers.set("X-Api-Key", xApiKey);
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getHome: builder.query<Home, { region: Region }>({
      query: ({ region }) =>
        `/v1/App/home/${{ all: "all", foreign: "en", iranian: "fa" }[region]}`,
      transformResponse: (data: Home, _meta, { region }) => {
        if (region === "foreign") {
          data.newest_en = (data as any).newest as Home["newest_en"];
          data.newest_fa = { total: 0, list: [] };
        } else if (region === "iranian") {
          data.newest_fa = (data as any).newest as Home["newest_fa"];
          data.newest_en = { total: 0, list: [] };
        }
        return data;
      },
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetHomeQuery, util: homeApiUtil } = homeApi;
